import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getPropsFromMeta } from "../../utils"
import CompMeta from '../../meta/LowCodeComponents/InsertTable';
const checkboxEnum = ['normal', 'hasCheckBox', 'hasCheckBox_child']

/**
 * @class NCInsertTable
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCInsertTable
 * @label 树状表格
 *
 */
class NCInsertTable extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
         * @title 区域编码
         * @description 组件标识
         */
        moduleId: PropTypes.string.isRequired,
        /**
         * @title 主表区域编码
         * @description 主表区域编码
         */
        headTableId: PropTypes.string.isRequired,
        /**
         * @title 子表区域编码
         * @description 子表区域编码
         */
        bodyTableId: PropTypes.string.isRequired,
        /**
         * @title 是否需要复选框
         * @description 是否需要复选框
         * @enumNames ['normal', 'hasCheckBox', 'hasCheckBox_child']
         */
        comType: PropTypes.oneOf(checkboxEnum),
        /**
         * @title 是否可拖拽
         * @description 是否可拖拽
         */
        isDrag: PropTypes.bool,
        /**
         * @title 是否显示序号列
         * @description 是否显示序号列
         */
        needIndex: PropTypes.bool,
        /**
         * @title 是否自适应高度
         * @description 是否自适应高度
         */
        adaptionHeight: PropTypes.bool,
        /**
         * @title 其他区域高度
         * @description 其他区域高度
         */
        otherAreaHeight: PropTypes.number,
        /**
         * @title 是否显示多行
         * @description 是否显示多行
         */
        multipleRowCell: PropTypes.bool,
        /**
         * @title 是否在弹窗内
         * @description 是否在弹窗内
         */
        inModal: PropTypes.bool,
        /**
         * @title 表格高度
         * @description 表格高度
         */
        insertTableHeight: PropTypes.number,
        /**
        * @title 是否可见
        * @description 是否可见
        */
        visible: PropTypes.bool,

    }
    static defaultProps = {
        needIndex: true,
        isDrag: true,
        adaptionHeight: false,
        multipleRowCell: false,
        inModal: false
    }
    static getCompMeta() {
        return CompMeta;
    }

    renderComp() {
        const { insertTable, headTableId, meta, config = {} } = this.props;
        const { createInsertTable } = insertTable;
        const configProps = getPropsFromMeta(this.props, NCInsertTable.getCompMeta());
        let metaData = meta.getMeta();
        let ret = null;
        let tableMetaData = metaData[headTableId];
        if (tableMetaData) {
            ret = (
                <React.Fragment>
                    {createInsertTable(Object.assign(configProps, config))}
                </React.Fragment>
            )
        } else {
            ret = (
                <div>没有绑定模板数据</div>
            )
        }
        return ret;
    }

    render() {
        return (
            <React.Fragment>
                {this.renderComp()}
            </React.Fragment>
        )
    }
}

export default NCInsertTable;
